var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 15.5846C11.5079 15.5846 12.9541 15.4357 14.2944 15.1624C15.9685 14.8212 16.8055 14.6506 17.5693 13.6685C18.3332 12.6864 18.3332 11.559 18.3332 9.30426L18.3332 7.69835C18.3332 5.44358 18.3332 4.31619 17.5693 3.33411C16.8055 2.35203 15.9685 2.18141 14.2944 1.84015C12.9541 1.56695 11.5079 1.41797 9.99984 1.41797C8.49177 1.41797 7.04558 1.56695 5.7053 1.84015C4.03122 2.18141 3.19418 2.35203 2.43034 3.33411C1.6665 4.31619 1.6665 5.44358 1.6665 7.69835L1.6665 9.30426C1.6665 11.559 1.6665 12.6864 2.43034 13.6685C3.19418 14.6506 4.03122 14.8212 5.7053 15.1624C7.04558 15.4357 8.49177 15.5846 9.99984 15.5846Z",
    stroke: "#337CC1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3642",
    d: "M13.3018 8.76138C13.1781 9.26625 12.5201 9.62885 11.204 10.354C9.77271 11.1428 9.05703 11.5371 8.47733 11.3852C8.281 11.3337 8.10017 11.2433 7.94832 11.1205C7.5 10.758 7.5 10.0056 7.5 8.50065C7.5 6.99572 7.5 6.24325 7.94832 5.8808C8.10017 5.75804 8.281 5.66756 8.47733 5.6161C9.05703 5.46416 9.7727 5.85853 11.204 6.64726C12.5201 7.37245 13.1781 7.73505 13.3018 8.23992C13.3439 8.4117 13.3439 8.5896 13.3018 8.76138Z",
    stroke: "#337CC1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e7120dcd4b7b136ec4bfb6de33d35688.svg";
export { ForwardRef as ReactComponent };